import React, { Component } from 'react';
import './Loading.css';

interface LoadingState {
  loaderState: boolean;
}

class Loading extends Component<{}, LoadingState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      loaderState: false,
    };
  }

  updateStatus = (status: boolean): void => {
    this.setState({ loaderState: status });
  };

  render(): JSX.Element | null {
    const { loaderState } = this.state;
    return (
      loaderState ? (
        <div className="loader2">
          <div className="an_animation">
            <span></span>
          </div>
        </div>
      ) : null
    );
  }
}

export default Loading;